<template>
  <BaseFetchData :action="fetchData">
    <template #default="fetchDataProps">
      <div v-if="fetchDataProps.status.resolved" class="flex p-8 space-x-8 bg-gray-50">
        <div class="flex-1">
          <div class="grid gap-4 grid-cols-3">
            <AudienceCard v-for="audience in audiences" :key="audience.id" :audience="audience" />
          </div>
        </div>
        <div v-if="funnel && funnel.stages" class="max-w-sm w-full">
          <FunnelChart :stages="funnel.stages" compact class="p-4 rounded-lg" />
        </div>
      </div>
    </template>
  </BaseFetchData>
</template>

<script>
import { funnelsClient } from '@/api/clients';
import { uniqBy } from 'lodash-es';
import FunnelChart from '@/components/Funnel/FunnelChart.vue';
import AudienceCard from './AudienceCard.vue';

export default {
  components: { FunnelChart, AudienceCard },
  props: {
    funnelId: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      funnel: null,
    };
  },
  computed: {
    audiences() {
      return uniqBy(
        (this.funnel?.stages || []).reduce((audiences, stage) => {
          const stageAudiences = JSON.parse(JSON.stringify(stage.audiences)).map(
            (stageAudience) => ({
              stageName: stage.name,
              ...stageAudience,
            })
          );

          return [...audiences, ...stageAudiences];
        }, []),
        'id'
      );
    },
  },
  methods: {
    fetchData() {
      return funnelsClient
        .read(this.funnelId, {
          include: [
            'stages.audiences.model',
            'stages.average_audience_count',
            'stages.audiences.cover',
          ],
        })
        .then((response) => {
          this.funnel = response.data;
        });
    },
  },
};
</script>
